import './Result.css';

export default function Result(props) {
  const escapeRegExp = (value) => {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const highlightKeyword = (text = '', keyword = '') => {
    if (!keyword.trim()) return text;

    const safeKeyword = escapeRegExp(keyword);
    const regex = new RegExp(`(${safeKeyword})`, 'gi');

    return text.split(regex).map((part, index) =>
      part.toLowerCase() === keyword.toLowerCase() ? (
        <mark className="keyword-highlight" key={index}>
          {part}
        </mark>
      ) : (
        <span key={index}>{part}</span>
      )
    );
  };

  const getHighlightedSnippet = (content = '', keyword = '') => {
    if (!content) return '';

    const normalizedKeyword = keyword?.trim();

    if (!normalizedKeyword) {
      return content;
    }

    const lines = content.split(/(?<=[.?!])\s+/);

    const matchingLines = lines.filter((line) =>
      line.toLowerCase().includes(normalizedKeyword.toLowerCase())
    );

    const selectedLines = matchingLines.slice(0, 2);

    if (selectedLines.length === 0) {
      return lines.slice(0, 2).join(' ');
    }

    return selectedLines.map((line, index) => (
      <span key={`${index}-${line.slice(0, 20)}`}>
        {highlightKeyword(line, normalizedKeyword)}{' '}
      </span>
    ));
  };

  const title = props.document?.title ?? '';
  const content = props.document?.content ?? '';
  const url = props.document?.url ?? '';
  const price = props.document?.price;
  const author = props.document?.author;
  const memberPrice = props.document?.memberPrice;
  const source = props.document?.source;
  const showSource = props.source ==="cim-eng"? true:false;

  const formattedTitle =
    title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();

  const hasPrice = price !== null && price !== undefined && price !== '';
  const hasAuthor =
    author !== null && author !== undefined && author.trim?.() !== '';
    const hasMemberPrice = memberPrice !== null && memberPrice !== undefined && memberPrice !== '';

  return (
    <article className="result">
  
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="result-link"
      >
        <div className="result-content">
 <div
  style={{
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: "12px",
    flexWrap: "nowrap",
  }}
>
  <h5
    className={`title-style ${
      props.source === "mag-eng" ? "title-style--mag-eng" : ""
    }`}
    style={{ margin: 0, minWidth: 0, flex: 1, width: "auto" }}
  >
    {formattedTitle}
  </h5>
{(showSource && <span
 className='source-pill'
  style={{
    flexShrink: 0,
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
    padding: "3px 10px",
    borderRadius: "999px",
    backgroundColor: "#f4f5f7",
    border: "1px solid #e8eaee",
    color: "#667085",
    fontSize: "11px",
    fontWeight: 500,
    lineHeight: "1.4",
  }}
>
  {source}
</span>)}
 
</div>
          <p className="description" >
            {getHighlightedSnippet(content, props.query)}
          </p>

          {(hasPrice || hasAuthor || hasMemberPrice) && (
            <div className="result-meta">
              {hasPrice && (
                <span className="meta-item price">
                  <span className="meta-label">Price</span>
                  <span className="meta-value">${price}</span>
                </span>
              )}
              {hasMemberPrice && (
                <span className="meta-item price">
                  <span className="meta-label">Member Price</span>
                  <span className="meta-value">${memberPrice}</span>
                </span>
              )}

              {hasAuthor && (
                <span className="meta-item author">
                  <span className="meta-label">Author</span>
                  <span className="meta-value">{author}</span>
                </span>
              )}
            </div>
          )}
        </div>

        <span className="result-arrow" aria-hidden="true">
          →
        </span>
      </a>
    </article>
  );
}